import React, { useState } from "react";
import { updateTournamentPodiums } from "services/tournamentService";
import * as Sentry from "@sentry/react";

const Trophy = ({ place, name }) => {
  const icons = { 1: "🏆", 2: "🥈", 3: "🥉" };
  return name ? (
    <div className="flex items-center gap-1 text-sm md:text-base">
      <span className="text-xl">{icons[place]}</span>
      <span>{name}</span>
    </div>
  ) : null;
};

const TournamentPodium = ({ tournament }) => {
  const [podiumName, setPodiumName] = useState("");
  const [first, setFirst] = useState("");
  const [second, setSecond] = useState("");
  const [third, setThird] = useState("");
  const [loading, setLoading] = useState(false);
  const [podiums, setPodiums] = useState(tournament.podiums || []);
  const [showModal, setShowModal] = useState(false);

  const handleDeletePodium = async (index) => {
    try {
      const updated = [...podiums];
      updated.splice(index, 1);
      await updateTournamentPodiums(tournament.id, updated);
      setPodiums(updated);
    } catch (error) {
      Sentry.captureException(error);
      console.error("Erreur lors de la suppression:", error);
      alert("Erreur lors de la suppression.");
    }
  };

  const handleAddPodium = async (e) => {
    e.preventDefault();
    if (!first && !second && !third) return;

    try {
      setLoading(true);
      const newPodium = {
        name: podiumName.trim(),
        first,
        second,
        third,
      };
      const newPodiums = [...podiums, newPodium];

      await updateTournamentPodiums(tournament.id, newPodiums);

      setPodiums(newPodiums);
      setPodiumName("");
      setFirst("");
      setSecond("");
      setThird("");
      setShowModal(false);
    } catch (error) {
      Sentry.captureException(error);
      console.error("Erreur lors de l'ajout du podium:", error);
      alert("Erreur lors de l'ajout.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-800 text-white p-6 shadow space-y-6">
      <div className="flex items-center justify-center gap-2">
        <h3 className="text-2xl font-bold">🏅 Résultats</h3>
        <button
          onClick={() => setShowModal(true)}
          className="bg-amber-500 hover:bg-amber-600 text-white px-2 py-1 rounded-md text-sm font-semibold"
        >
          Ajouter un podium
        </button>
      </div>

      {podiums.length > 0 && (
        <div className="flex flex-wrap gap-4 justify-center">
          {podiums.map((podium, i) => (
            <div
              key={i}
              className="relative flex flex-col items-start gap-2 shadow-xl rounded-md p-4 bg-gray-800 min-w-[280px] sm:min-w-[320px] max-w-sm flex-1"
            >
              <button
                onClick={() => handleDeletePodium(i)}
                className="absolute top-2 right-2 text-white bg-red-700 hover:bg-red-600 font-bold p-1 rounded-md text-sm"
              >
                Supprimer
              </button>

              <div className="text-lg font-semibold text-amber-400">
                {podium.name || ""}
              </div>
              <Trophy place={1} name={podium.first} />
              <Trophy place={2} name={podium.second} />
              <Trophy place={3} name={podium.third} />
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
          <div className="bg-gray-900 rounded-lg shadow-xl p-6 max-w-lg w-full">
            <h4 className="text-xl font-bold text-center mb-4">
              Ajouter un podium
            </h4>

            <form onSubmit={handleAddPodium} className="space-y-4">
              <div>
                <label className="block mb-1">
                  Titre du podium (optionnel)
                </label>
                <input
                  type="text"
                  value={podiumName}
                  onChange={(e) => setPodiumName(e.target.value)}
                  className="w-full bg-gray-800 border border-gray-600 p-2 rounded"
                  placeholder="Ex: Tournoi Principal, Consolante..."
                />
              </div>

              <div className="flex flex-col gap-4">
                <div>
                  <label className="block mb-1">🏆 1er</label>
                  <input
                    type="text"
                    value={first}
                    onChange={(e) => setFirst(e.target.value)}
                    className="w-full bg-gray-800 border border-gray-600 p-2 rounded"
                  />
                </div>
                <div>
                  <label className="block mb-1">🥈 2e</label>
                  <input
                    type="text"
                    value={second}
                    onChange={(e) => setSecond(e.target.value)}
                    className="w-full bg-gray-800 border border-gray-600 p-2 rounded"
                  />
                </div>
                <div>
                  <label className="block mb-1">🥉 3e</label>
                  <input
                    type="text"
                    value={third}
                    onChange={(e) => setThird(e.target.value)}
                    className="w-full bg-gray-800 border border-gray-600 p-2 rounded"
                  />
                </div>
              </div>

              <div className="flex justify-between mt-4">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 bg-gray-600 hover:bg-gray-500 text-white rounded-md"
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-4 py-2 bg-green-600 hover:bg-green-500 text-white rounded-md font-semibold"
                >
                  {loading ? "Enregistrement..." : "Ajouter"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default TournamentPodium;
